import jwtDecode, { JwtPayload } from "jwt-decode";

export interface ScoutOtelToken extends JwtPayload {
  // User Id
  user?: string;
  // Account Id
  acc?: string;
  // Seconds to Live
  ttl?: number;
  // App Group Id
  grp?: string;
  // Environment
  env?: string;
  // Request Id
  rid?: string;
  // Role
  rbac?: string;
}

/**
 * Attempt to decode base64 encoded jwt token. Will return undefined if the
 * jwt fails to decode or if the token is expired.
 * @param token base64 encoded jwt token
 * @returns decoded ScoutOtelToken or undefined
 */
export function decodeJwt(
  token: string | undefined
): ScoutOtelToken | undefined {
  let decodedToken;
  try {
    decodedToken = token ? jwtDecode<ScoutOtelToken>(atob(token)) : undefined;
  } catch (err) {
    // continue regardless of decode error.
  } finally {
    if (!isValid(decodedToken)) {
      decodedToken = undefined;
    }
  }
  return decodedToken;
}

/**
 * Check validity of a token. Currently just considers expiration.
 * @param token ScoutOtelToken in question
 * @returns A boolean indicating validity
 */
export function isValid(token: ScoutOtelToken | undefined): boolean {
  return !!(token?.exp && token.exp > Date.now() / 1000);
}
